import { useTranslation } from "react-i18next";
import { FeatureBlockContent, FeatureBlockSection } from "../../FeatureBlockElements";
import HBText from "../../honeybook-ui/HBText/HBText";
import HBMediaElement from "../../honeybook-ui/HBMediaElement/HBMediaElement";
import ImageTextElement from "../../ImageTextElement/ImageTextElement";
import VerticalFeatureBlockStore from "./VerticalFeatureBlockStore";
import { GeneratedTemplateType } from "../../../types/util-types";
import "./vertical-feature-block.scss";

interface Props {
    templateType: GeneratedTemplateType;
}

const VerticalFeatureBlock = ({templateType = GeneratedTemplateType.CONTRACT}: Props) => {
    const { t } = useTranslation();
    const featureData = VerticalFeatureBlockStore[templateType] || [];

    return (
        <FeatureBlockSection customClass="vertical-feature-block">
            <FeatureBlockContent customClass="vertical-feature-block__content">
                <div className="container-for-curve"></div>
                <HBText
                type="title-l"
                customClass="vertical-feature-block__title"
                >
                {t(featureData.title) as string}
                </HBText>
                <HBText
                type="body-s"
                customClass="vertical-feature-block__subtitle"
                >
                {t(featureData.subtitle) as string}
                </HBText>
                <HBMediaElement
                    name={`marketing_site/ai_templates/mockups/${templateType}.png`}
                    alt="mockup"
                    customClass="vertical-feature-block__media"
                />
                {featureData.gridItems.length > 0 && (
                    <div className="vertical-feature-block__grid">
                        {featureData.gridItems.map(feature => (
                            <div
                                className="vertical-feature-block__grid-item"
                                key={`${feature.transId}.title`}
                            >
                                <ImageTextElement
                                    customClass={feature.customClass}
                                    imagePath={feature.imagePath}
                                    title={t(`${feature.transId}.title`)}
                                    description={t(
                                        `${feature.transId}.description`
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </FeatureBlockContent>
        </FeatureBlockSection>
    );
};

export default VerticalFeatureBlock;
